// MeclisUyeleri.tsx
import React, { ReactElement, useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import ContactsGrid from "../../components/yenimahalle/ContactsGrid";
import PortalPeopleApi from "../../api/PortalPeopleApi";
import { MeclisUyeleriList, MuhtarList, VicePresiten } from "../../models/Response/PortalPeople";

// ContactsGrid için kullanılacak card arayüzü
interface Card {
  imageSrc: string;
  title: string;
  description: ReactElement;
  titleText: string;
}

const BaskanYardimcilari: React.FC = () => {
  const [cards, setCards] = useState<Card[]>([]);

  useEffect(() => {
    // API'den meclis üyeleri verisini çekiyoruz
    const fetchData = async () => {
      const response = await PortalPeopleApi.getVicePresidents();
      if (response && response.content.vicePresitens) {
        const mappedCards = response.content.vicePresitens.map((item: VicePresiten) => ({
          imageSrc: item.imageUrl,
          title: item.nameSurname,
          description: (
            <>
              <i>{item.cv}</i>
            </>
          ),
          titleText: "",
        }));
        setCards(mappedCards);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader headingLine1="" headingLine2="Başkan Yardımcıları" />
      <ContactsGrid cards={cards} showTitleText={false} />
    </Layout>
  );
};

export default BaskanYardimcilari;
